const category_list = {
    heard_title: "商品分类",
    heard_btn: "新增",
    form_ph1: "请选择商品分类",
    table_label1: "分类名称",
    table_label2: "排序",
    table_btn1: "编辑",
    table_btn2: "删除",
    dialog_title1: "商品分类",
    dialog_label1: "分类名称:",
    dialog_label2: "分类排序:",
    rule_msg1: "排序必须为数字",
    rule_msg2: "排序已重复",
    rule_msg3: "请输入分类名称"
};

export default category_list;
